import { makeStyles } from "@material-ui/styles";
import React from "react";
import { pageTheme } from "@backstage/theme";
import datadogLogo from "../../../media/images/datadog.png";
import honeybadgerLogo from "../../../media/images/honeybadger.jpg";
import opsgenieLogo from "../../../media/images/opsgenie.png";
import kajabiLogo from "../../../media/images/kajabi.png";
import { Vendor } from "@internal/plugin-ops-review-common";
import { InformationTooltip } from "../../InformationTooltip";

const useStyles = makeStyles(() => ({
  container: {
    display: "block",
    width: "100%",
    background: "red",
    textAlign: "center",
    fontWeight: "bold",
    padding: "10px 0",
    backgroundImage: pageTheme.app.backgroundImage,
    borderRadius: "5px",
  },
  title: {
    fontSize: "36px",
    color: "white",
  },
  image: {
    width: 48,
    height: 48,
    borderRadius: "5px",
    position: "relative",
    top: "10px",
    marginRight: "20px",
  },
  tooltip: {
    marginLeft: "20px",
  },
}));

interface Props {
  title: string;
  vendor?: Vendor;
  tooltip?: NonNullable<React.ReactNode>;
}

export const TeamBreakdownHeader: React.FC<Props> = ({
  title,
  vendor = "datadog",
  tooltip,
}): JSX.Element => {
  const classes = useStyles();

  let image;
  let alt;

  switch (vendor) {
    case "datadog":
      image = datadogLogo;
      alt = "Datadog";
      break;
    case "honeybadger":
      image = honeybadgerLogo;
      alt = "Honeybadger";
      break;
    case "opsgenie":
      image = opsgenieLogo;
      alt = "OpsGenie";
      break;
    case "kajabi":
      image = kajabiLogo;
      alt = "Kajabi";
      break;
    default:
      image = datadogLogo;
      alt = "Datadog";
  }

  return (
    <div className={classes.container}>
      <img src={image} alt={alt} className={classes.image} />
      <span className={classes.title}>{title}</span>
      {tooltip && (
        <InformationTooltip title={tooltip} className={classes.tooltip} />
      )}
    </div>
  );
};
